import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {RootState} from "@/store/types/RootState";

import {homeMatchDetailsModalInitialState} from "../constants/home_match_details_modal_initial_state";
import {homeMatchRejectModalInitialState} from "../constants/home_match_reject_modal_initial_state";
import {homeMatchServiceResignationModalInitialState} from "../constants/home_match_service_resignation_modal_initial_state";
import {HomeMatchDetailsCtaVariant} from "../types/HomeMatchDetailsCtaVariant";
import {IHomeMatchState} from "../types/IHomeMatchState";

export const homeMatchSlice = createSlice({
    name: "homeMatch",
    initialState: {
        detailsModal: homeMatchDetailsModalInitialState,
        openRecommendationsWhenReady: false,
        pendingRecommendationsRefreshes: 0,
        rejectModal: homeMatchRejectModalInitialState,
        serviceResignationModal: homeMatchServiceResignationModalInitialState
    } as IHomeMatchState,
    reducers: {
        startHomeMatchRecommendationsRefresh: (state) => {
            state.pendingRecommendationsRefreshes += 1;
        },
        finishHomeMatchRecommendationsRefresh: (state) => {
            state.pendingRecommendationsRefreshes = Math.max(state.pendingRecommendationsRefreshes - 1, 0);
        },
        requestHomeMatchRecommendationsOpen: (state) => {
            state.openRecommendationsWhenReady = true;
        },
        clearHomeMatchRecommendationsOpen: (state) => {
            state.openRecommendationsWhenReady = false;
        },
        openHomeMatchDetailsModal: (
            state,
            action: PayloadAction<Omit<IHomeMatchState["detailsModal"], "ctaVariant" | "isOpen"> & {ctaVariant?: HomeMatchDetailsCtaVariant}>
        ) => {
            state.detailsModal = {
                ctaVariant: action.payload.ctaVariant ?? HomeMatchDetailsCtaVariant.MY_INQUIRIES,
                isOpen: true,
                preleadId: action.payload.preleadId,
                viewType: action.payload.viewType
            };
        },
        updateHomeMatchDetailsModal: (state, action: PayloadAction<Pick<IHomeMatchState["detailsModal"], "preleadId">>) => {
            state.detailsModal = {
                ...state.detailsModal,
                preleadId: action.payload.preleadId
            };
        },
        closeHomeMatchDetailsModal: (state) => {
            state.detailsModal = homeMatchDetailsModalInitialState;
        },
        openHomeMatchRejectModal: (state, action: PayloadAction<{preleadId: number}>) => {
            state.rejectModal = {
                isOpen: true,
                preleadId: action.payload.preleadId
            };
        },
        closeHomeMatchRejectModal: (state) => {
            state.rejectModal = homeMatchRejectModalInitialState;
        }
    }
});

export const selectHomeMatchRecommendationsRefreshing = (state: RootState) => state.homeMatch.pendingRecommendationsRefreshes > 0;
export const selectHomeMatchRecommendationsOpenWhenReady = (state: RootState) => state.homeMatch.openRecommendationsWhenReady;
export const selectHomeMatchDetailsModal = (state: RootState) => state.homeMatch.detailsModal;
export const selectHomeMatchRejectModal = (state: RootState) => state.homeMatch.rejectModal;
export const selectHomeMatchServiceResignationModal = (state: RootState) => state.homeMatch.serviceResignationModal;
export const {
    closeHomeMatchDetailsModal,
    closeHomeMatchRejectModal,
    clearHomeMatchRecommendationsOpen,
    finishHomeMatchRecommendationsRefresh,
    openHomeMatchDetailsModal,
    requestHomeMatchRecommendationsOpen,
    openHomeMatchRejectModal,
    startHomeMatchRecommendationsRefresh,
    updateHomeMatchDetailsModal
} = homeMatchSlice.actions;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {RootState} from "@/store/types/RootState";

import {homeMatchDetailsModalInitialState} from "../constants/home_match_details_modal_initial_state";
import {homeMatchRejectModalInitialState} from "../constants/home_match_reject_modal_initial_state";
import {homeMatchServiceResignationModalInitialState} from "../constants/home_match_service_resignation_modal_initial_state";
import {HomeMatchDetailsCtaVariant} from "../types/HomeMatchDetailsCtaVariant";
import {IHomeMatchState} from "../types/IHomeMatchState";

export const homeMatchSlice = createSlice({
    name: "homeMatch",
    initialState: {
        detailsModal: homeMatchDetailsModalInitialState,
        openRecommendationsWhenReady: false,
        pendingRecommendationsRefreshes: 0,
        rejectModal: homeMatchRejectModalInitialState,
        serviceResignationModal: homeMatchServiceResignationModalInitialState
    } as IHomeMatchState,
    reducers: {
        startHomeMatchRecommendationsRefresh: (state) => {
            state.pendingRecommendationsRefreshes += 1;
        },
        finishHomeMatchRecommendationsRefresh: (state) => {
            state.pendingRecommendationsRefreshes = Math.max(state.pendingRecommendationsRefreshes - 1, 0);
        },
        requestHomeMatchRecommendationsOpen: (state) => {
            state.openRecommendationsWhenReady = true;
        },
        clearHomeMatchRecommendationsOpen: (state) => {
            state.openRecommendationsWhenReady = false;
        },
        openHomeMatchDetailsModal: (
            state,
            action: PayloadAction<Omit<IHomeMatchState["detailsModal"], "ctaVariant" | "isOpen"> & {ctaVariant?: HomeMatchDetailsCtaVariant}>
        ) => {
            state.detailsModal = {
                ctaVariant: action.payload.ctaVariant ?? HomeMatchDetailsCtaVariant.MY_INQUIRIES,
                isOpen: true,
                preleadId: action.payload.preleadId,
                viewType: action.payload.viewType
            };
        },
        updateHomeMatchDetailsModal: (state, action: PayloadAction<Pick<IHomeMatchState["detailsModal"], "preleadId">>) => {
            state.detailsModal = {
                ...state.detailsModal,
                preleadId: action.payload.preleadId
            };
        },
        closeHomeMatchDetailsModal: (state) => {
            state.detailsModal = homeMatchDetailsModalInitialState;
        },
        openHomeMatchRejectModal: (state, action: PayloadAction<{preleadId: number}>) => {
            state.rejectModal = {
                isOpen: true,
                preleadId: action.payload.preleadId
            };
        },
        closeHomeMatchRejectModal: (state) => {
            state.rejectModal = homeMatchRejectModalInitialState;
        }
    }
});

export const selectHomeMatchRecommendationsRefreshing = (state: RootState) => state.homeMatch.pendingRecommendationsRefreshes > 0;
export const selectHomeMatchRecommendationsOpenWhenReady = (state: RootState) => state.homeMatch.openRecommendationsWhenReady;
export const selectHomeMatchDetailsModal = (state: RootState) => state.homeMatch.detailsModal;
export const selectHomeMatchRejectModal = (state: RootState) => state.homeMatch.rejectModal;
export const selectHomeMatchServiceResignationModal = (state: RootState) => state.homeMatch.serviceResignationModal;
export const {
    closeHomeMatchDetailsModal,
    closeHomeMatchRejectModal,
    clearHomeMatchRecommendationsOpen,
    finishHomeMatchRecommendationsRefresh,
    openHomeMatchDetailsModal,
    requestHomeMatchRecommendationsOpen,
    openHomeMatchRejectModal,
    startHomeMatchRecommendationsRefresh,
    updateHomeMatchDetailsModal
} = homeMatchSlice.actions;
